export function loadJsonData(jsonFilePath, async_mode) {
  // async_mode
  // true  : default -> async
  // false : -> sync
  const path = jsonFilePath;

  let sync_flg = true;
  if (!async_mode) {
    sync_flg = false;
  } else if (async_mode === true) {
    sync_flg = true;
  } else {
    sync_flg = true;
  }

  return $.ajax({
    type: "GET",
    url: path,
    async: sync_flg,
  });
}

export function concatJson(array){

    const result = {
        "data": []
    }

      array.forEach((elm) => {
        loadJsonData(elm, false)
          .done(function (res) {
            // category_code を取得
            const category_code = res[0].category_code;
            // console.log(elm)
            // data に concat で既存の配列と結合 data を単一の配列として扱うため
            result.data = result.data.concat(res);

          })
          .fail(function (result) {
            // console.log("error : ", statusText);
            console.log("result : ", result);
          });
      });

      return result;
}